import Pie from "./Charts/PieChart";
import Bar from "./Charts/BarChart";
import Line from "./Charts/LineChart";
import Radar from "./Charts/RadarChart";

export const PieChart = Pie
export const BarChart = Bar
export const LineChart = Line
export const RadarChart = Radar